import React, { useState } from 'react';

import amWarning from '../../../../../../assets/img/accountmanagement/am-warning.svg';

import tickIcon from '../../../../../../assets/img/tick.svg';
import closeIcon from '../../../../../../assets/img/delete.svg';

import styles from './ImpactPostsListAddEditPopup.module.css';

import BasicSettings from './components/BasicSettings/BasicSettings';
import Loader from '../../../../../../campaigns/components/Loader/Loader';

export default ({
  activePopup,
  title,
  // subtitle1,
  onSubmit,
  onClose,
  submitLoading,
  refetchList,
  setActivePopup,
  validate = () => true
}) => {
  const [datePickerPopupVisible, setDatePickerPopupVisible] = useState(false);
  const [containerTopScroll, setContainerTopScroll] = useState(0);

  const [internalPost, setInternalPost] = useState(
    activePopup && activePopup.post
      ? { ...activePopup.post }
      : {
          content: []
        }
  );
  const [error, setError] = useState(null);

  const isValid = validate(internalPost);

  const listOptionsDivScroll = async event => {
    const elem = event.currentTarget;
    setContainerTopScroll(-1 * elem.scrollTop);
  };

  const setInternalPostAction = r => {
    setInternalPost(r);
    setError(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.contentContainer} onScroll={listOptionsDivScroll}>
        <BasicSettings
          internalPost={internalPost}
          setInternalPost={r => setInternalPostAction(r)}
          activePopup={activePopup}
          datePickerPopupVisible={datePickerPopupVisible}
          setDatePickerPopupVisible={setDatePickerPopupVisible}
          containerTopScroll={containerTopScroll}
        />
      </div>
      {error ? (
        <div className={styles.errorContainer}>
          <img
            className={styles.warningErrorIcon}
            alt="Touchpoints tooltip"
            src={amWarning}
          />
          {error}
        </div>
      ) : null}
      <div className={styles.footer}>
        <div />
        <div className={styles.actions}>
          {submitLoading && (
            <div className={styles.loaderContainer}>
              <Loader size="small" />
            </div>
          )}
          {!submitLoading && [
            isValid ? (
              <img
                key="submit-button"
                className={`${
                  styles.confirm
                } workspaces-manage-workspace-confirm-button`}
                src={tickIcon}
                alt="Confirm icon"
                onClick={async () => {
                  const processedInternalPost = { ...internalPost };

                  if (
                    processedInternalPost &&
                    processedInternalPost.__typename
                  ) {
                    delete processedInternalPost.__typename;
                  }

                  if (
                    processedInternalPost &&
                    processedInternalPost.content &&
                    processedInternalPost.content.length
                  ) {
                    processedInternalPost.content.forEach(c => {
                      if (c && c.__typename) {
                        // eslint-disable-next-line
                        delete c.__typename;
                      }

                      if (c && Object.hasOwn(c, 'imageFullPath')) {
                        // eslint-disable-next-line
                        delete c.imageFullPath;
                      }

                      if (
                        c &&
                        Object.hasOwn(c, 'socialMediaCardImageFullPath')
                      ) {
                        // eslint-disable-next-line
                        delete c.socialMediaCardImageFullPath;
                      }
                    });
                  }

                  const res = await onSubmit({
                    variables: processedInternalPost
                  });

                  const actionPath =
                    activePopup && activePopup.post
                      ? 'updateImpactPost'
                      : 'createImpactPost';

                  if (
                    res &&
                    res.data &&
                    res.data[actionPath] &&
                    res.data[actionPath].done
                  ) {
                    setActivePopup(null);
                    await refetchList();
                  }

                  if (
                    res &&
                    res.data &&
                    res.data[actionPath] &&
                    !res.data[actionPath].done
                  ) {
                    if (
                      res.data[actionPath].errors &&
                      res.data[actionPath].errors.length
                    ) {
                      setError(res.data[actionPath].errors[0].message);
                    }
                  }
                }}
                role="presentation"
              />
            ) : (
              <img
                key="submit-button"
                className={`${styles.confirm} ${
                  styles.invalid
                } workspaces-manage-workspace-confirm-button`}
                src={tickIcon}
                alt="Confirm icon"
              />
            ),
            <img
              key="close-button"
              className={styles.close}
              src={closeIcon}
              alt="Close icon"
              onClick={() => onClose()}
              role="presentation"
            />
          ]}
        </div>
      </div>
    </div>
  );
};
